import { Box, BoxProps, Container, Flex, Heading } from '@chakra-ui/react';
import { CMS } from '@waitroom/models';
import * as React from 'react';
import Markdown from '../../Markdown/Markdown';
import GridItem from '../Grid/GridItem/GridItem';

const Features = ({
  heading,
  content,
  items,
  cardContent,
  ...rest
}: CMS.Features & BoxProps): React.ReactElement | null => {
  const itemsUi = items?.map((item, i) => (
    <GridItem
      key={i}
      horizontal
      item={item}
      index={i}
      px={0}
      sx={{
        li: {
          mb: 1,
        },
      }}
    />
  ));
  return (
    <Box {...rest}>
      <Container maxW="container.2xl">
        {heading || content ? (
          <Flex
            w="full"
            flexDirection="column"
            justify="center"
            textAlign="center"
            rowGap={8}
            mb={12}
            maxW="1000px"
            mx="auto"
          >
            {heading && (
              <Heading as="h2" size="5xl" lineHeight="shorter">
                {heading}
              </Heading>
            )}
            {content && <Markdown fontSize="xl">{content}</Markdown>}
          </Flex>
        ) : null}
        <Flex
          direction={{ base: 'column', xl: 'row' }}
          w="full"
          align="flex-start"
          gap={[10, 12, 14, 16]}
        >
          <Flex
            direction="column"
            w={{ base: 'full', xl: '45%' }}
            align={{ base: 'center', xl: 'flex-start' }}
          >
            {itemsUi}
          </Flex>
          <Box
            w={{ base: 'full', xl: '55%' }}
            bgColor="white"
            rounded="xl"
            boxShadow="card"
            px={[6, 8, 10]}
            py={[8, 10, 12, 14]}
            mt={[0, 0, 6]}
          >
            {
              <Markdown
                fontSize="lg"
                sx={{
                  'h3,h4,h5': {
                    fontWeight: 800,
                    mb: 8,
                  },
                  ul: {
                    columnCount: { base: 1, xl: 2 },
                    columnGap: '2.5rem',
                  },
                }}
              >
                {cardContent || ''}
              </Markdown>
            }
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};
export default Features;
